import React, { useEffect, useState } from "react";
import { Container, Dropdown, Tab, Tabs } from "react-bootstrap";
import TransactionsAnalysis from "./transactionsanalysis";
import TransactionsAssessment from "./transactionsassessment";
import TransactionsActions from "./transactionsaction";


const Transactionsindex = () => {
    const [tabs] = useState([
        { id: 1, sub_category: 'Transactions Analysis' },
        { id: 2, sub_category: 'Transactions Assessment' },
        { id: 3, sub_category: 'Transactions Actions' },
    ]);

    const [activeTab, setActiveTab] = useState('Transactions Analysis');
    const [isMobile, setIsMobile] = useState(false);

    const handleTabSelect = (key) => {
        setActiveTab(key); 
    };

    const getTabContent = (tabName, activeTab) => {
        switch (tabName) {
            case 'Transactions Analysis':
                return <TransactionsAnalysis activeTab={activeTab} />;
            case 'Transactions Assessment':
                return <TransactionsAssessment activeTab={activeTab} />;
            case 'Transactions Actions':
                return <TransactionsActions activeTab={activeTab} />;
            default:
                return null;
        }
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768); 
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
       
        <Container fluid>
            {isMobile ? (
                <>
                    <Dropdown>
                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                            {activeTab}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            {tabs.map((tab) => (
                                <Dropdown.Item
                                    key={tab.id}
                                    onClick={() => handleTabSelect(tab.sub_category)}
                                >
                                    {tab.sub_category}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                    {getTabContent(activeTab)} 
                </>
            ) : (
                <Tabs
                    activeKey={activeTab}
                    onSelect={handleTabSelect}
                    id="justify-tab-example"
                    className="border-tab nav-primary mb-3"
                >
                    {tabs.map(tab => (
                        <Tab key={tab.id} eventKey={tab.sub_category} title={tab.sub_category}>
                            {getTabContent(tab.sub_category)} 
                        </Tab>
                    ))}
                </Tabs>
            )}
        </Container>
    );
};

export default Transactionsindex;
